/**
 * One toggle chip — "Open", "Blocking", "Waiting for re-check" (UX §4 F2/F3).
 * Unlike `FilterBar`'s segmented group these three toggle independently and
 * are not mutually exclusive, so they are drawn here rather than forced into
 * that shared control. Reading is not editing: always `data-nonmutating`.
 */
export function Chip({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      data-nonmutating
      aria-pressed={active}
      onClick={onClick}
      className={[
        "inline-flex h-8 items-center rounded-ks-sm border px-3 text-[13px] transition-colors",
        active
          ? "border-ks-purple-3 bg-ks-purple-4 font-semibold text-ks-purple"
          : "border-ks-grey-4 bg-ks-surface text-ks-ink hover:bg-muted",
      ].join(" ")}
    >
      {label}
    </button>
  );
}
